import { render, staticRenderFns } from "./PzForwardButton.vue?vue&type=template&id=37e977cf"
import script from "./PzForwardButton.vue?vue&type=script&lang=js"
export * from "./PzForwardButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37e977cf')) {
      api.createRecord('37e977cf', component.options)
    } else {
      api.reload('37e977cf', component.options)
    }
    module.hot.accept("./PzForwardButton.vue?vue&type=template&id=37e977cf", function () {
      api.rerender('37e977cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/Buttons/PzForwardButton.vue"
export default component.exports